import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import messages from './ExtNavComponent.messages';
import metadata from './ExtNavComponent.metadata.json5';
import ExtNavTripDetailsComponent from '../ExtNavTripDetailsTable/ExtNavTripDetailsComponent';
import MarinaDetailsTableComponent from '../MarinaDetailsTable/MarinaDetailsTableComponent'
import CrewMembersTableComponent from '../CrewMembersTable/CrewMembersTableComponent'


function ExtNavComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated,index, offeringCode, boatVm, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ExtNavComponent');
    const modelVM = _.get(submissionVM, pathUpdated);
    const {addNewRowToOtherTable, updateAddNewRowToOtherTable} = false;

    if(modelVM && modelVM.value) {
        modelVM.value.isValidationReq = true;
    }

    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        braIfOthPleDesFie: {
            visible: _.get(modelVM.value, 'braFie') === 'Oth'
        },
        ifOthExpFie: {
            visible: _.get(modelVM.value, 'proTypFie') === 'Oth'
        },
        ifothexpFie1: {
            visible: _.get(modelVM.value, 'hulMatFie') === 'Oth'
        }, 
        ifYesExpFie: {
            visible: _.get(modelVM.value, 'areTheAnyModPowOroOthFie') === true
        },
        tripsTableComponent: {
            data: modelVM.tripDetails || [],
            updateWizardData,
            index,
            submissionVM,
            extNavTripDetailsTablePath: `${pathUpdated}.tripDetails`,
            addNewRowToOtherTable,
            basePath: pathUpdated
        },
        crewMembersTableComponent: {
            data: modelVM.crewMembers ? modelVM.crewMembers : [],
            updateWizardData,
            index,
            submissionVM,
            crewMembersTablePath: `${pathUpdated}.crewMembers`
        },
        marinaDetailsTableComponent:{
            data: modelVM.marinaDetails ? modelVM.marinaDetails : [],
            updateWizardData,
            submissionVM,
            index,
            marinaDetailsTablePath: `${pathUpdated}.marinaDetails`
        },
        
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            extNavTripDetailsTable: ExtNavTripDetailsComponent,
            crewMembersTableComponent: CrewMembersTableComponent,
            marinaDetailsTableComponent: MarinaDetailsTableComponent
        },
        //resolveClassNameMap: styles,
    };

    const readValue = useCallback((id, path) =>
         readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ExtNavComponent.propTypes = wizardProps;
export default withRouter(ExtNavComponent);
